<template>
  <div class="row pt-3">
    <div class="col">
      <div class="alert alert-success p-2 mx-3">{{ message }}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "successAlert",
  props: {
    message: "",
  }
}
</script>